import PropTypes from 'prop-types';
import cn from 'classnames';

import './cocRangeBar.scss';

export default function  CoCRangeBar ({ label = '',
                                        min = 'N/A',
                                        max = 'N/A',
                                        minOut = null ,
                                        maxOut = null,
                                        status = '' })
{
  return (
    <div className={cn('coc-range-bar', status)}>
      <div className="range-bar-label">{label}</div>

      <div className="range-bar-container">

        {(minOut !== null) && <div className="out-value" style={{left: '13%'}}>
          {minOut}
          <div className="out-value-indicator" style={{left: '10%'}}/>
        </div>}

        {(maxOut !== null) && <div className="out-value" style={{left: '87%'}}>
          {maxOut}
          <div className="out-value-indicator" style={{left: '90%'}}/>
        </div>}

        <div className="range-bar">
          <div className='range-out'/>
          <div className={cn('range-in', {active: status})}/>
          <div className='range-out'/>
        </div>
      </div>

      <div className="range-bar-values">
        <div className="min-range-value" style={{left: '20%'}}>{min}</div>
        <div className="max-range-value" style={{left: '80%'}}>{max}</div>
      </div>
    </div>
  );
}

CoCRangeBar.propTypes = {
  label: PropTypes.string,
  min: PropTypes.number,
  max: PropTypes.number,
  minOut: PropTypes.number,
  maxOut: PropTypes.number,
  status: PropTypes.string,
};
